<template>
  <div class="partyserve">
    <div class="header">
      <!-- <div class="title">丰富多样的服务</div> -->
      <img :src="party3" alt="">
      <div class="border"></div>
    </div>

    <div class="titlelist">
      <div
        class="titleitem"
        :class="titleId == item.id ? 'active' : ''"
        v-for="item in titleList"
        :key="item.id"
        @click="clickTitle(item.id)"
      >
        {{ item.title }}
      </div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <div class="box" v-if="item.id == titleId">
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
            <div class="list1">
              <div class="item1" v-for="it in item.list" :key="it.id">
                <img :src="it.logo" alt="" />
                <div>{{ it.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import party3 from '../../../assets/party/party3.png'

import partyserve1 from "../../../assets/party/partyserve1.png";
import partyserve2 from "../../../assets/party/partyserve2.png";
import partyserve3 from "../../../assets/party/partyserve3.png";
import partyserve4 from "../../../assets/party/partyserve4.png";
import partyserve5 from "../../../assets/party/partyserve5.png";
import partyserve6 from "../../../assets/party/partyserve6.png";
import partyserve7 from "../../../assets/party/partyserve7.png";
import partyserve8 from "../../../assets/party/partyserve8.png";
import partyserve9 from "../../../assets/party/partyserve9.png";
import partyserve10 from "../../../assets/party/partyserve10.png";
import partyserve11 from "../../../assets/party/partyserve11.png";
import partyserve12 from "../../../assets/party/partyserve12.png";
import partyserve13 from "../../../assets/party/partyserve13.png";
import partyserve14 from "../../../assets/party/partyserve14.png";
import partyserve15 from "../../../assets/party/partyserve15.png";
import partyserve16 from "../../../assets/party/partyserve16.png";

export default {
  setup() {
    return reactive({
      party3:party3,
      titleId: 1,
      titleList: [
        {
          id: 1,
          title: "党建策划",
        },
        {
          id: 2,
          title: "智慧党建",
        },
        {
          id: 3,
          title: "内容服务",
        },
        {
          id: 4,
          title: "运营服务",
        },
      ],
      list: [
        {
          id: 1,
          title: "党建策划",
          text: "提供一站式的组织生活活动的策划、组织、开展、宣传和活动空间的党建服务工作，通过对当前社区的工作梳理，提炼工作特色，整理出符合社区特色的党建策划书，一对一打造专属该社区的党建品牌",
          list: [
            {
              id: 1,
              logo: partyserve1,
              title: "党建视频",
            },
            {
              id: 2,
              logo: partyserve2,
              title: "活动策划",
            },
            {
              id: 3,
              logo: partyserve3,
              title: "党建活动",
            },
            {
              id: 4,
              logo: partyserve4,
              title: "党建宣传",
            },
          ],
        },
        {
          id: 2,
          title: "智慧党建",
          text: "畅月数字家园智慧党建平台运用最新的互联网、大数据、区块链、GIS地图技术，构建一个全新的线上阵地，为党员和党组织建立沟通的桥梁",
          list: [
            {
              id: 1,
              logo: partyserve5,
              title: "党员管理",
            },
            {
              id: 2,
              logo: partyserve6,
              title: "“四有活动”管理",
            },
            {
              id: 3,
              logo: partyserve7,
              title: "党建数据平台",
            },
            {
              id: 4,
              logo: partyserve8,
              title: "党建后台管理",
            },
          ],
        },
        {
          id: 3,
          title: "内容服务",
          text: "畅月数字家园依托多年软件开发经验，遵循《中国共产党章程》、党内相关规章制度及管理办法，结合党建实际工作，运用“互联网”+理念，打造集政治建设、思想建设、组织建设、作风建设、制度建设、廉政建设和精神文明建设为一体，专注于党务管理和党建创新的智慧党建平台。",
          list: [
            {
              id: 1,
              logo: partyserve9,
              title: "党建资讯平台",
            },
            {
              id: 2,
              logo: partyserve10,
              title: "组织信息管理平台",
            },
            {
              id: 3,
              logo: partyserve11,
              title: "党员管理平台",
            },
            {
              id: 4,
              logo: partyserve12,
              title: "数据分析平台",
            },
          ],
        },
        {
          id: 4,
          title: "运营服务",
          text: "畅月数字家园智慧党建有产品运营、推广服务、阵地运营等产品运营服务。在推广服务中结合线下智能硬件设备联合线上系统两种模式进行。+理念，打造集政治建设、思想建设、组织建设、作风建设、制度建设、廉政建设和精神文明建设为一体，专注于党务管理和党建创新的智慧党建平台。",
          list: [
            {
              id: 1,
              logo: partyserve13,
              title: "智慧党建推广",
            },
            {
              id: 2,
              logo: partyserve14,
              title: "平台运营",
            },
            {
              id: 3,
              logo: partyserve15,
              title: "红色课程培训",
            },
            {
              id: 4,
              logo: partyserve16,
              title: "党建会议筹备",
            },
          ],
        },
      ],
    });
  },
  methods: {
    clickTitle(id) {
      this.titleId = id;
    },
  },
};
</script>

<style scoped>
.partyserve {
  width: 1180px;
  margin: 80px auto 0;
}
.header {
  text-align: center;
}
.header img {
  width: 226px;
  margin: 0 auto;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #a2231d;
  margin: 20px auto 0;
}

.titlelist {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.titlelist .titleitem {
  padding: 13px 27px;
  margin: 25px;
  cursor: pointer;
}
.titlelist .active {
  background: #9f231d;
  border-radius: 93px 93px 93px 93px;
  color: #fff;
}

.body {
  margin-top: 40px;
}
.body .list .item .box {
    height: 160px;
  padding: 40px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
}
.body .list .item .box .title {
  font-size: 16px;
  color: #2a3d50;
}
.body .list .item .box .text {
  font-size: 12px;
  color: #3d3d3d;
  margin-top: 20px;
}
.body .list .item .box .list1 {
  display: flex;
  justify-content: space-evenly;
  margin-top: 40px;
}
.body .list .item .box .list1 .item1 {
  text-align: center;
}
.body .list .item .box .list1 .item1 img {
  width: 27px;
}
.body .list .item .box .list1 .item1 div {
  margin-top: 20;
  font-size: 12px;
  color: #2a3d50;
}
</style>
